import { generateEligibilityBreakdownPdf } from 'api/Pdf';

import { streamPdf } from './lib/streamPdf';

export const downloadEligibilityBreakdownPdf = ({
  navigate,
  patientId,
  memberId,
  insuranceType,
  benefitVersionId,
  taskId,
  appointmentId,
  practiceId,
  title = 'Benefits breakdown',
  view = false,
  print = false,
  viewTab
}) =>
  streamPdf({
    request: (disposition) =>
      generateEligibilityBreakdownPdf(navigate, {
        patientId,
        memberId,
        insuranceType,
        benefitVersionId,
        taskId,
        appointmentId,
        practiceId,
        disposition
      }),
    title,
    view,
    print,
    viewTab,
    context: { patientId, benefitVersionId, taskId, appointmentId }
  });
